import React, { Fragment, useEffect, useState } from 'react';
import RightSidebar from 'components/right-sidebar';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import BottomNavigation from 'components/bottom-navigation';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import PageHeaderText from 'components/base/page-header-text';
import { getCareerDetailsNav } from './utils';
import useNewCareerPositionContext from 'contexts/career-position.context';
import { parseBulletPoints } from 'pages/create-career-position/create-job-details/utils';
import { ENUM_JOB_STATUS } from 'utils/enum';
import DeleteModal from 'components/base/delete-modal';

const CreateJobContent = () => {
  const { setRightSection } = useDashboardContext();
  const { disabled, createJobPositionForm } = useNewCareerPositionContext();
  const [loading, setLoading] = useState(false);
  const [jobStatusOption, setJobStatusOption] = useState<ENUM_JOB_STATUS>(ENUM_JOB_STATUS.open);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const careerDetailsNav = getCareerDetailsNav(location.search);

  const payload = {
    role: createJobPositionForm.jobTitle,
    department: createJobPositionForm.department,
    description: createJobPositionForm.roleSummary,
    responsibilities: parseBulletPoints(createJobPositionForm.responsibilities),
    qualifications: parseBulletPoints(createJobPositionForm.qualifications),
    work_mode: createJobPositionForm.workMode,
    experience_level: createJobPositionForm.experience,
    locations: [createJobPositionForm.location],
    application_deadline: createJobPositionForm.applicationDeadline
      ? createJobPositionForm.applicationDeadline
      : undefined,
    no_of_openings: Number(createJobPositionForm.noOfOpenings),
    status: jobStatusOption
  };
  useEffect(() => {
    setRightSection(<RightSidebar list={careerDetailsNav} />);
    return () => {
      setRightSection(null);
    };
  }, []);

  const handleConfirmForm = async () => {
    setLoading(true);

    try {
      await apiService.post('careers/jobs', {
        data: payload
      });

      toast(
        <ToastMessage
          type='success'
          message={`Job ${
            jobStatusOption === ENUM_JOB_STATUS.draft ? 'saved' : 'created'
          } successfully `}
        />
      );
    } catch {
      toast(
        <ToastMessage
          type='error'
          message={`There was a problem ${
            jobStatusOption === ENUM_JOB_STATUS.draft ? 'saving' : 'creating'
          } position `}
        />
      );
    } finally {
      setLoading(false);
      setOpenConfirmModal(false);
      navigate('/careers');
    }
  };

  return (
    <Fragment>
      <div className='flex items-center'>
        <PageHeaderText title='New Position' description='Add a new open position' />
      </div>
      <Outlet />

      <div className='flex items-center gap-4'>
        <BottomNavigation
          loading={loading}
          list={careerDetailsNav}
          onConfirm={handleConfirmForm}
          disabled={disabled}
          secondaryBtn={
            <Button
              onClick={() => {
                setJobStatusOption(ENUM_JOB_STATUS.draft);
                setOpenConfirmModal(true);
              }}
              variant='link'
              size='x-small'
              color='primary'
              className='w-fit h-fit self-end mb-1'>
              Save as draft
            </Button>
          }
        />
      </div>

      <DeleteModal
        onClose={() => setOpenConfirmModal(false)}
        show={openConfirmModal}
        description={`Are you sure you want to save this position as draft?`}
        handleDelete={() => {
          handleConfirmForm();
        }}
        loading={loading}
        title={`Save as draft?`}
        type='save'
        emoji='🥳'
      />
    </Fragment>
  );
};

export default CreateJobContent;
